import RecycledMoney from "components/Icons/RecycledMoney";
import { stringToSlug } from "functions/slug";
import { SVGProps } from "react";

// Slug to SVG Map
const PRODUCT_ICON_MAP: Record<string, SVGProps<SVGElement>> = {
	// 'recycled-money': <RecycledMoney />,
	// 'recycled-money-arms': <RecycledMoney />
}

// Passing title since previous implementations didn't pass slugs.
const ProductSpecificIcon = ({ productTitle } : { productTitle: string; }) => {
	
	const productSlug = stringToSlug(productTitle);

	if (PRODUCT_ICON_MAP[productSlug] == null) {
		return null;
	}
	
	return (
		<div className="absolute top-[10px] left-[10px] z-10">
			{ PRODUCT_ICON_MAP[productSlug] }
		</div>
	);
};

export default ProductSpecificIcon;